import React from 'react';
import ModuleContainer from '@/components/module-container';
import Header from './header';
import Banner from './banner';
import Advantage from './advantage';
import ImageContent from './image-content';
import FcuntionIntro from './funtion-intro';
import DeepCustomers from './deep-customers';
import PageFooter from './page-footer';

import s from './index.module.less';

// const contentWidth = 1420;
const contentWidth = 1280;
const MIN_WIDTH = 1420;

const Index = () => (
  <div style={{ minWidth: MIN_WIDTH }}>
    <Header />
    <Banner contentWidth={contentWidth} />
    <ModuleContainer id="overview" title="API 全生命周期智能管理平台" className={s.overview} contentWidth={contentWidth}>
      <ImageContent />
    </ModuleContainer>
    <ModuleContainer id="productDescription" title="提供更多场景的 API 管理及测试需求" contentWidth={contentWidth}>
      <FcuntionIntro />
    </ModuleContainer>
    <ModuleContainer id="coreAdvantages" title="产品特性" className={s.advantage} contentWidth={contentWidth}>
      <Advantage />
    </ModuleContainer>
    <ModuleContainer id="customerCase" title="ifBook  助力客户成功" className={s.deepCustomers} contentWidth={contentWidth} suTitle="ifBook 为众多行业的研发团队提效，相信未来 ifBook 一定能成为行业的推动者，将 ifBook 的 API 理念带给更多用户">
      <DeepCustomers />
    </ModuleContainer>
    <PageFooter />
  </div>
);

export default Index;
